module.exports = __webpack_public_path__ + "public/images/about-14.8849d797494e560d894cc04bf0f225bc.png";